import type { SiteDictionary } from '../content/site-content';

const ITEMS = ['i1', 'i2', 'i3', 'i4'] as const;

/**
 * The bar under the headline. It is the subtitle: instead of a sentence explaining the thesis, the
 * same order runs past in four contradictory states, which is the thesis.
 *
 * The visible track is duplicated so the translation can loop seamlessly and is hidden from
 * assistive technology; the scene reaches a screen reader once, as prose, through `ticker.alt`.
 * Reduced motion stops the travel and leaves the four states legible in place.
 */
export function StateTicker({ dictionary }: { dictionary: SiteDictionary }) {
  const t = (key: string) => dictionary[key] ?? key;
  const track = ITEMS.map((key) => t(`ticker.${key}`));

  return (
    <div className="ticker">
      <p className="visually-hidden">{t('ticker.alt')}</p>
      <div className="ticker__viewport" aria-hidden="true">
        {[0, 1].map((copy) => (
          <div className="ticker__track" key={copy}>
            {track.map((item) => (
              <span className="ticker__item" key={item}>
                {item}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
